// extracted by mini-css-extract-plugin
export default {"title":"content-information-module--title--SrOZV","content":"content-information-module--content--837i6"};